
export const previewVersion = { name: "Preview", publicationDate: new Date(), isDefault: false };
